(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (window.location.search.indexOf('variant=') !== -1) return;

    document
      .querySelectorAll('variant-picker[data-product-handle="intellipump"] input[type="radio"][value="ApexApple"]')
      .forEach(function (input) {
        if (input.checked) return;

        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  });
  } catch(e) { console.error(e); }
})();

})();
